import api from "./axios"

export async function getAllStudents() {
  const res = await api.get("/students/");
  return res.data; // raw backend list
}

export async function addStudent({ username, full_name, house, year }) {
  const payload = {
    username,
    full_name,
    house,
    year,
  };

  const res = await api.post("/students/", payload);
  return res.data;
}

export async function getFullNameByUserId(userId) {
  const res = await api.get(`/students/${userId}/`);
  return res.data.full_name;
}

export async function getUserIdByUsername(username) {
  const res = await api.get(`/students/userid/${username}/`);
  return res.data.user_id;
}

export async function deleteStudent(userId) {
  await api.delete(`/students/${userId}/`);
}

export async function updateStudent(userId, updatedData) {
  const res = await api.patch(`/students/${userId}/`, updatedData);
  return res.data;
}
